import msDataProvider from "@/services/msDataProvider";

export async function checkLocalStore() {

    const localStore = {
        userId: sessionStorage.getItem('userId'),
        displayName: sessionStorage.getItem('displayName'),
        phoneNumber: sessionStorage.getItem('phoneNumber'),
        agentVersion: sessionStorage.getItem('agentVersion'),
        deviceId: sessionStorage.getItem('deviceId'),
        deviceName: sessionStorage.getItem('deviceName'),
        email: sessionStorage.getItem('email'),
        os: sessionStorage.getItem('os'),
        serverName: sessionStorage.getItem('serverName'),
        loginName: sessionStorage.getItem('loginName'),
    }
    if ((localStore && localStore.userId) && (localStore.displayName || localStore.phoneNumber || localStore.loginName ||
        localStore.agentVersion || localStore.deviceId || localStore.deviceName || localStore.os || localStore.email || localStore.serverName)) {
        return localStore
    }
    try {
        const binding = {
            authenAuthenInfo: await msDataProvider.getData("authenAuthenInfo"),
            deviceBasicInfo: await msDataProvider.getData("deviceBasicInfo")
        }
        if (binding && binding.authenAuthenInfo && binding.authenAuthenInfo.user_info) {
            if (binding.authenAuthenInfo.user_info.user_id) {
                sessionStorage.setItem('userId', binding.authenAuthenInfo.user_info.user_id)
            }
            if (binding.authenAuthenInfo.user_info.display_name) {
                sessionStorage.setItem('displayName', binding.authenAuthenInfo.user_info.display_name)
            }
            if (binding.authenAuthenInfo.user_info.phone_number) {
                sessionStorage.setItem('phoneNumber', binding.authenAuthenInfo.user_info.phone_number)
            }
            if (binding.authenAuthenInfo.user_info.email) {
                sessionStorage.setItem('email', binding.authenAuthenInfo.user_info.email)
            }
        }
        if (binding && binding.deviceBasicInfo && binding.deviceBasicInfo.data) {
            if (binding.deviceBasicInfo.data.agent_version) {
                sessionStorage.setItem('agentVersion', binding.deviceBasicInfo.data.agent_version)
            }
            if (binding.deviceBasicInfo.data.device_id) {
                sessionStorage.setItem('deviceId', binding.deviceBasicInfo.data.device_id)
            }
            if (binding.deviceBasicInfo.data.device_name) {
                sessionStorage.setItem('deviceName', binding.deviceBasicInfo.data.device_name)
            }
        }
        const params = {
            displayName: binding && binding.authenAuthenInfo && binding.authenAuthenInfo.user_info && binding.authenAuthenInfo.user_info.display_name || sessionStorage.getItem('displayName') || "",
            email: binding && binding.authenAuthenInfo && binding.authenAuthenInfo.user_info && binding.authenAuthenInfo.user_info.email || sessionStorage.getItem('email') || "",
            phoneNumber: binding && binding.authenAuthenInfo && binding.authenAuthenInfo.user_info && binding.authenAuthenInfo.user_info.phone_number || sessionStorage.getItem('phoneNumber') || "",
            agentVersion: binding && binding.deviceBasicInfo && binding.deviceBasicInfo.data && binding.deviceBasicInfo.data.agent_version || sessionStorage.getItem('agentVersion') || "",
            deviceId: binding && binding.deviceBasicInfo && binding.deviceBasicInfo.data && binding.deviceBasicInfo.data.device_id || sessionStorage.getItem('deviceId') || "",
            deviceName: binding && binding.deviceBasicInfo && binding.deviceBasicInfo.data && binding.deviceBasicInfo.data.device_name || sessionStorage.getItem('deviceName') || "",
            os: sessionStorage.getItem('os'),
            serverName: sessionStorage.getItem('serverName'),
            loginName: sessionStorage.getItem('loginName'),
        }
        return params
    } catch (e) {
        console.log(e)
    }
}
